import React from 'react';
import {Route} from 'react-router';
import auth from '../../utils/auth';

const PrivateRoute: React.FC<any> = ({component: Component, path}: any) => {
  if (!auth.isAuthenticated()) {
    auth.login();
    return null;
  }
  return <Route path={path} render={() => <Component />} />;
};

export default PrivateRoute;



// WEBPACK FOOTER //
// ./src/components/PrivateRoute/PrivateRoute.tsx